import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_zm6eavqgy2: FaireBrandEntity = {
  token: "b_zm6eavqgy2",
  type: "brand",
  name: "SELV RITUEL",
  avatarUrl:
    "https://cdn.faire.com/fastly/3869f440bcb500ca4787ef398a2bfea2a888f128b9457f984f6bfc6ca91b3833.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/343e5cbf2cca5b9ed8df40fdacb9c103a91dcaa559a6a553e1dc3b405789dc96.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3869f440bcb500ca4787ef398a2bfea2a888f128b9457f984f6bfc6ca91b3833.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/343e5cbf2cca5b9ed8df40fdacb9c103a91dcaa559a6a553e1dc3b405789dc96.jpeg",
  location: "Montreal, QC, CAN",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 25,
  isInsider: false,
  description:
    "Selv offers you a daily wellness experience inviting the union between your body, your mind and your environment.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:28.980Z",
    importedBy: "entity-db-cli",
  },
};
